import React from "react";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";
import ServiceAccountsTable from "../components/ServiceAccountsTable/ServiceAccountsTable";

const ServiceAccountsPage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.service-accounts"));

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 1000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-end",
        marginTop: "2.5rem",
      }}
    >
      {/* Spacer so all tables are at the same height */}
      <div style={{ height: "2.5rem" }}></div>
      <ServiceAccountsTable />
    </div>
  );
};

export default ServiceAccountsPage;
